"use client";
import { opacity as a } from "../../helpers/color/color.js";
import { COLORS as e } from "../../tokens/colors/Colors.js";
const i = Object.freeze({
  error: {
    alias: "redBase",
    base: e.redBase,
    light: a(e.redBase, 0.1)
  },
  info: {
    alias: "brand",
    base: e.brand,
    light: a(e.brand, 0.1)
  },
  success: {
    alias: "greenBase",
    base: e.greenBase,
    light: a(e.greenBase, 0.1)
  },
  warning: {
    alias: "orangeDark",
    base: e.orangeDark,
    light: a(e.orangeDark, 0.1)
  }
});
export {
  i as COLOR_SEVERITY
};
